// Article data structure
const articles = [
    {
        id: 'venezuela-gangs',
        title: 'Venezuelan Gang Deportations: Trump\'s Early Warning Vindicated',
        category: 'immigration',
        date: '2024-03-18',
        readTime: '5 min',
        image: 'images/venezuela-gang.jpg',
        excerpt: 'Trump\'s 2023 campaign warnings about violent Venezuelan gang members entering the country are now being validated as Biden\'s administration begins deporting them.',
        featured: true
    },
    // Add more articles here
];

// DOM Elements
const feedGrid = document.querySelector('.feed-grid');
const filterButtons = document.querySelectorAll('.filter-btn');
const loadMoreBtn = document.querySelector('.load-more button');

// State
let currentFilter = 'all';
let currentPage = 1;
const articlesPerPage = 9;

// Initialize
document.addEventListener('DOMContentLoaded', () => {
    renderArticles();
    setupFilters();
    setupLoadMore();
});

// Render articles
function renderArticles(filteredArticles = articles) {
    const start = 0;
    const end = currentPage * articlesPerPage;
    const articlesToShow = filteredArticles.slice(start, end);
    
    if (!feedGrid) return;
    feedGrid.innerHTML = articlesToShow.map(article => `
        <article class="article-card">
            <div class="card-header">
                <div class="card-category">${article.category.toUpperCase()}</div>
            </div>
            <div class="card-image">
                <img src="${article.image}" alt="${article.title}">
            </div>
            <div class="card-content">
                <h3>${article.title}</h3>
                <p>${article.excerpt}</p>
                <div class="card-meta">
                    <span class="date">${formatDate(article.date)}</span>
                    <span class="read-time">${article.readTime} read</span>
                </div>
                <a href="articles/${article.id}.html" class="read-more">Read Analysis <i class="fas fa-arrow-right"></i></a>
            </div>
        </article>
    `).join('');

    // Show/hide load more button
    loadMoreBtn.style.display = end >= filteredArticles.length ? 'none' : 'block';
}

// Setup filters
function setupFilters() {
    filterButtons.forEach(button => {
        button.addEventListener('click', () => {
            // Update active state
            filterButtons.forEach(btn => btn.classList.remove('active'));
            button.classList.add('active');

            // Update filter
            currentFilter = button.dataset.filter;
            currentPage = 1; // Reset pagination

            // Filter and render articles
            const filteredArticles = currentFilter === 'all' 
                ? articles 
                : articles.filter(article => article.category === currentFilter);
            
            renderArticles(filteredArticles);
        });
    });
}

// Setup load more
function setupLoadMore() {
    loadMoreBtn.addEventListener('click', () => {
        currentPage++;
        const filteredArticles = currentFilter === 'all' 
            ? articles 
            : articles.filter(article => article.category === currentFilter);
        
        renderArticles(filteredArticles);
    });
}

// Format date
function formatDate(dateString) {
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return new Date(dateString).toLocaleDateString('en-US', options);
}

// Mobile menu toggle
const mobileMenuToggle = document.querySelector('.mobile-menu-toggle');
const mainNav = document.querySelector('#main-nav');

// bind once: scripts.js and main.js both bind this toggle on some pages; double-bind opened and closed the menu in one tap
if (mobileMenuToggle && !mobileMenuToggle.dataset.navBound) {
    mobileMenuToggle.dataset.navBound = '1';
    mobileMenuToggle.addEventListener('click', () => {
        mainNav.classList.toggle('active');
        mobileMenuToggle.classList.toggle('active');
        document.body.classList.toggle('menu-open');
    });
}

// Newsletter form submission
const newsletterForm = document.querySelector('.newsletter-form');
if (newsletterForm) {
    newsletterForm.addEventListener('submit', (e) => {
        e.preventDefault();
        const email = newsletterForm.querySelector('input[type="email"]').value;
        // Add newsletter subscription logic here
        alert('Thank you for subscribing!');
        newsletterForm.reset();
    });
}

// Lazy load YouTube videos
document.addEventListener('DOMContentLoaded', function() {
    const videoPlaceholders = document.querySelectorAll('.video-placeholder');
    
    videoPlaceholders.forEach(placeholder => {
        placeholder.addEventListener('click', function() {
            const videoId = this.getAttribute('data-video-id');
            const startTime = this.getAttribute('data-start-time') || 0;
            
            // Create iframe only when clicked
            const iframe = document.createElement('iframe');
            iframe.setAttribute('width', '100%');
            iframe.setAttribute('height', '450');
            iframe.setAttribute('src', `https://www.youtube.com/embed/${videoId}?autoplay=1&start=${startTime}`);
            iframe.setAttribute('title', 'YouTube video player');
            iframe.setAttribute('frameborder', '0');
            iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share');
            iframe.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
            iframe.setAttribute('allowfullscreen', '');
            
            // Replace placeholder with iframe
            this.parentNode.replaceChild(iframe, this);
        });
    });
}); 